export default {
  IFRAME_ID: 'gp-payment-iframe',
  SUBMIT_BUTTON_ID: 'gp-submit-button'
}